unit uWebClientViewer;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, VCL.TMSFNCTypes, VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes,
  VCL.TMSFNCCustomControl, VCL.TMSFNCSplitter, VCL.TMSFNCTreeViewBase, VCL.TMSFNCTreeViewData, VCL.TMSFNCCustomTreeView, VCL.TMSFNCTreeView,
  VCL.TMSFNCObjectInspector, x.WebSocket.Shared, x.WebSocket.client, Vcl.StdCtrls, WEBLib.StdCtrls, x.ao;

type
  TFormClientList = class(TForm)
    pnlTop: TPanel;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    WebPanel4: TPanel;
    TMSFNCSplitter1: TTMSFNCSplitter;
    tv: TTMSFNCTreeView;
    pnlBot: TPanel;
    ix: TTMSFNCObjectInspector;
    lbc: TLabel;
    lbt: TLabel;
    pnlMain: TPanel;
    procedure tvAfterSelectNode(Sender: TObject; ANode: TTMSFNCTreeViewVirtualNode);
    procedure WebFormCreate(Sender: TObject);
  private
    Ftitle: string;
    fCLients: tXWSclients;
    FClient: txwsClient;
    procedure SetClient(const Value: txwsClient);
    procedure SetCLients(const Value: tXWSclients);
    procedure setTitle(const Value: string);
    { Private declarations }
  public
   procedure reload;
   property Clients: tXWSclients read fCLients write SetCLients;
   property Client: txwsClient read FClient write SetClient;
   property title: string read Ftitle write setTitle;
  protected procedure LoadDFMValues; override; end;

var
  FormClientList: TFormClientList;

implementation

{$R *.dfm}

procedure TFormClientList.WebFormCreate(Sender: TObject);
begin
 ix.NodesAppearance.CollapseNodeIcon:=nil;
ix.NodesAppearance.CollapseNodeIconLarge:=nil;

ix.NodesAppearance.ExpandNodeIcon:=nil;
ix.NodesAppearance.ExpandNodeIconLarge:=nil;
 ix.ColumnsAppearance.TopSize:=0;
 tv.ColumnsAppearance.TopSize:=0;

end;

{ TFormClientList }

procedure TFormClientList.reload;
begin
    if assigned(fclients) then

 setClients(fclients);
end;

procedure TFormClientList.SetClient(const Value: txwsClient);
begin
    FClient := Value;
  ix.&Object:=value;
  if assigned(value)=false then exit;

  //if value.canSend then bsend.Enabled:=true else bsend.Enabled:=false;
 //if value.isServer then bDisCon.Enabled:=true else bDisCOn.Enabled:=false;
end;

procedure TFormClientList.SetCLients(const Value: tXWSclients);
var
 cb: txwsClientBase;
 ac: txwsClient;
 n: ttmsfncTreeViewNode;
 i: integer;
begin
  fCLients := Value;
  if value=nil then
  begin
   lbc.caption:='NIL';
   exit;
  end;

  lbc.caption:=inttostr(value.Count);
  tv.Columns[0].Text:='Clients (' + inttostr(value.Count) + ')';
  tv.BeginUpdate;

  tv.Nodes.Clear;
  Client:=nil;
   console.log('Viewing items', value.count);
  for i:=1 to value.Count do
  begin
 // if assigned(value[i-1]) then
 // begin
    console.log('Item ' + inttostr(i-1),value[i-1]) ;
    ac:=txwsClient(value[i-1]);
    n:=tv.Nodes.Add;
    n.DataObject:=ac;
    n.Text[0]:='<b>' + ac.name + '</b><BR>' +
    ac.guidShort;
  //end;
  end;
  {for cb in value do
  begin
   console.log('client', cb);
    ac:=txwsClient(cb);
    n:=tv.Nodes.Add;
    n.DataObject:=ac;
    n.Text[0]:='<b>' + ac.name + '</b><BR>' +
    ac.guid;

  end;  }
  if tv.Nodes.Count<>0 then
  begin
    tv.SelectNode(tv.Nodes[0]);
    Client:=txwsClient(tv.Nodes[0].DataObject);
  end;
  tv.EndUpdate;
end;

procedure TFormClientList.setTitle(const Value: string);
begin
  Ftitle := Value;
  lbt.caption:=value;
  caption:='Clients - ' + value;
pnltop.Visible:=value<>'';

end;

procedure TFormClientList.tvAfterSelectNode(Sender: TObject; ANode:
    TTMSFNCTreeViewVirtualNode);
begin
if assigned(anode)=false then exit;
if assigned(anode.Node)=false then exit;
if assigned(anode.Node.DataObject)=false then exit;

 Client:=txwsClient(anode.Node.DataObject);
end;

procedure TFormClientList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMain := TPanel.Create(Self);
  pnlTop := TPanel.Create(Self);
  lbc := TLabel.Create(Self);
  lbt := TLabel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  tv := TTMSFNCTreeView.Create(Self);
  WebPanel4 := TPanel.Create(Self);
  pnlBot := TPanel.Create(Self);
  ix := TTMSFNCObjectInspector.Create(Self);
  TMSFNCSplitter1 := TTMSFNCSplitter.Create(Self);

  pnlMain.BeforeLoadDFMValues;
  pnlTop.BeforeLoadDFMValues;
  lbc.BeforeLoadDFMValues;
  lbt.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  tv.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  pnlBot.BeforeLoadDFMValues;
  ix.BeforeLoadDFMValues;
  TMSFNCSplitter1.BeforeLoadDFMValues;
  try
    Name := 'FormClientList';
    Width := 640;
    Height := 480;
    Align := alClient;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMain.SetParentComponent(Self);
    pnlMain.Name := 'pnlMain';
    pnlMain.Left := 0;
    pnlMain.Top := 0;
    pnlMain.Width := 640;
    pnlMain.Height := 480;
    pnlMain.Margins.Left := 3;
    pnlMain.Margins.Top := 3;
    pnlMain.Margins.Right := 3;
    pnlMain.Margins.Bottom := 3;
    pnlMain.Align := alClient;
    pnlMain.Caption := 'pnlMain';
    pnlMain.ChildOrder := 2;
    pnlTop.SetParentComponent(pnlMain);
    pnlTop.Name := 'pnlTop';
    pnlTop.Left := 0;
    pnlTop.Top := 0;
    pnlTop.Width := 640;
    pnlTop.Height := 32;
    pnlTop.Margins.Left := 3;
    pnlTop.Margins.Top := 3;
    pnlTop.Margins.Right := 3;
    pnlTop.Margins.Bottom := 3;
    pnlTop.Align := alTop;
    pnlTop.BorderStyle := bsNone;
    lbc.SetParentComponent(pnlTop);
    lbc.Name := 'lbc';
    lbc.AlignWithMargins := True;
    lbc.Left := 32;
    lbc.Top := 3;
    lbc.Width := 21;
    lbc.Height := 26;
    lbc.Margins.Left := 3;
    lbc.Margins.Top := 3;
    lbc.Margins.Right := 3;
    lbc.Margins.Bottom := 3;
    lbc.Align := alLeft;
    lbc.Caption := 'lbc';
    lbc.Font.Charset := DEFAULT_CHARSET;
    lbc.Font.Color := clWindowText;
    lbc.Font.Height := -16;
    lbc.Font.Name := 'Segoe UI';
    lbc.Font.Style := [];
    lbc.HeightPercent := 100.000000000000000000;
    lbc.Layout := tlCenter;
    lbc.ParentFont := False;
    lbc.WidthPercent := 100.000000000000000000;
    lbt.SetParentComponent(pnlTop);
    lbt.Name := 'lbt';
    lbt.AlignWithMargins := True;
    lbt.Left := 3;
    lbt.Top := 3;
    lbt.Width := 22;
    lbt.Height := 26;
    lbt.Margins.Left := 3;
    lbt.Margins.Top := 3;
    lbt.Margins.Right := 4;
    lbt.Margins.Bottom := 3;
    lbt.Align := alLeft;
    lbt.Caption := 'lbc';
    lbt.Font.Charset := DEFAULT_CHARSET;
    lbt.Font.Color := clWindowText;
    lbt.Font.Height := -16;
    lbt.Font.Name := 'Segoe UI';
    lbt.Font.Style := [fsBold];
    lbt.HeightPercent := 100.000000000000000000;
    lbt.Layout := tlCenter;
    lbt.ParentFont := False;
    lbt.WidthPercent := 100.000000000000000000;
    WebPanel2.SetParentComponent(pnlMain);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 32;
    WebPanel2.Width := 640;
    WebPanel2.Height := 448;
    WebPanel2.Margins.Left := 3;
    WebPanel2.Margins.Top := 3;
    WebPanel2.Margins.Right := 3;
    WebPanel2.Margins.Bottom := 3;
    WebPanel2.Align := alClient;
    WebPanel2.BorderStyle := bsNone;
    WebPanel2.ChildOrder := 1;
    WebPanel3.SetParentComponent(WebPanel2);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 0;
    WebPanel3.Width := 216;
    WebPanel3.Height := 448;
    WebPanel3.Margins.Left := 3;
    WebPanel3.Margins.Top := 3;
    WebPanel3.Margins.Right := 3;
    WebPanel3.Margins.Bottom := 3;
    WebPanel3.Align := alLeft;
    WebPanel3.BorderStyle := bsNone;
    tv.SetParentComponent(WebPanel3);
    tv.Name := 'tv';
    tv.Left := 0;
    tv.Top := 0;
    tv.Width := 216;
    tv.Height := 448;
    tv.Margins.Left := 3;
    tv.Margins.Top := 3;
    tv.Margins.Right := 3;
    tv.Margins.Bottom := 3;
    tv.Align := alClient;
    tv.BevelEdges := [];
    tv.BevelInner := bvNone;
    tv.BevelOuter := bvNone;
    tv.ParentDoubleBuffered := False;
    tv.DoubleBuffered := False;
    tv.TabOrder := 0;
    tv.Stroke.Kind := gskNone;
    tv.Stroke.Color := 11119017;
    tv.GroupsAppearance.TopSize := 100.000000000000000000;
    tv.GroupsAppearance.BottomSize := 100.000000000000000000;
    tv.GroupsAppearance.TopFill.Kind := gfkNone;
    tv.GroupsAppearance.BottomFill.Kind := gfkNone;
    tv.GroupsAppearance.TopFont.Charset := DEFAULT_CHARSET;
    tv.GroupsAppearance.TopFont.Color := 4539717;
    tv.GroupsAppearance.TopFont.Height := -32;
    tv.GroupsAppearance.TopFont.Name := 'Segoe UI';
    tv.GroupsAppearance.TopFont.Style := [];
    tv.GroupsAppearance.BottomFont.Charset := DEFAULT_CHARSET;
    tv.GroupsAppearance.BottomFont.Color := 4539717;
    tv.GroupsAppearance.BottomFont.Height := -32;
    tv.GroupsAppearance.BottomFont.Name := 'Segoe UI';
    tv.GroupsAppearance.BottomFont.Style := [];
    tv.Columns.Clear;
    with tv.Columns.Add do
    begin
      Name := 'Column0';
      Text := 'Name';
      Width := 200.000000000000000000;
      UseDefaultAppearance := False;
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clBlack;
      Font.Height := -16;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      TopFont.Charset := DEFAULT_CHARSET;
      TopFont.Color := clWindowText;
      TopFont.Height := -22;
      TopFont.Name := 'Segoe UI';
      TopFont.Style := [];
      BottomFont.Charset := DEFAULT_CHARSET;
      BottomFont.Color := clWindowText;
      BottomFont.Height := -22;
      BottomFont.Name := 'Segoe UI';
      BottomFont.Style := [];
      Filtering.DropDownWidth := 200;
      Filtering.DropDownHeight := 240;
      Filtering.ButtonSize := 30.000000000000000000;
    end;
    tv.ColumnsAppearance.StretchColumn := 0;
    tv.ColumnsAppearance.StretchAll := False;
    tv.ColumnsAppearance.TopSize := 72.000000000000000000;
    tv.ColumnsAppearance.BottomSize := 50.000000000000000000;
    tv.ColumnsAppearance.TopFont.Charset := DEFAULT_CHARSET;
    tv.ColumnsAppearance.TopFont.Color := 4539717;
    tv.ColumnsAppearance.TopFont.Height := -32;
    tv.ColumnsAppearance.TopFont.Name := 'Segoe UI';
    tv.ColumnsAppearance.TopFont.Style := [fsBold];
    tv.ColumnsAppearance.BottomFont.Charset := DEFAULT_CHARSET;
    tv.ColumnsAppearance.BottomFont.Color := 4539717;
    tv.ColumnsAppearance.BottomFont.Height := -32;
    tv.ColumnsAppearance.BottomFont.Name := 'Segoe UI';
    tv.ColumnsAppearance.BottomFont.Style := [];
    tv.ColumnsAppearance.TopFill.Color := 16380654;
    tv.ColumnsAppearance.BottomFill.Kind := gfkNone;
    tv.ColumnsAppearance.BottomFill.Color := 16380654;
    tv.ColumnsAppearance.TopStroke.Kind := gskNone;
    tv.NodesAppearance.ShowFocus := False;
    tv.NodesAppearance.ExpandWidth := 15.000000000000000000;
    tv.NodesAppearance.ExpandHeight := 15.000000000000000000;
    tv.NodesAppearance.LevelIndent := 5.000000000000000000;
    tv.NodesAppearance.FixedHeight := 50.000000000000000000;
    tv.NodesAppearance.VariableMinimumHeight := 50.000000000000000000;
    tv.NodesAppearance.ShowLines := False;
    tv.NodesAppearance.Font.Charset := DEFAULT_CHARSET;
    tv.NodesAppearance.Font.Color := clBlack;
    tv.NodesAppearance.Font.Height := -32;
    tv.NodesAppearance.Font.Name := 'Segoe UI';
    tv.NodesAppearance.Font.Style := [];
    tv.NodesAppearance.TitleFont.Charset := DEFAULT_CHARSET;
    tv.NodesAppearance.TitleFont.Color := clBlack;
    tv.NodesAppearance.TitleFont.Height := -32;
    tv.NodesAppearance.TitleFont.Name := 'Segoe UI';
    tv.NodesAppearance.TitleFont.Style := [];
    tv.NodesAppearance.SelectedFontColor := 4539717;
    tv.NodesAppearance.ExtendedFontColor := 4539717;
    tv.NodesAppearance.SelectedFill.Color := 16578806;
    tv.NodesAppearance.SelectedStroke.Kind := gskNone;
    tv.NodesAppearance.SelectedStroke.Color := 15702829;
    tv.NodesAppearance.SelectedStroke.Width := 2.000000000000000000;
    tv.NodesAppearance.SelectionArea := tsaFull;
    tv.NodesAppearance.ExtendedFont.Charset := DEFAULT_CHARSET;
    tv.NodesAppearance.ExtendedFont.Color := clWindowText;
    tv.NodesAppearance.ExtendedFont.Height := -32;
    tv.NodesAppearance.ExtendedFont.Name := 'Segoe UI';
    tv.NodesAppearance.ExtendedFont.Style := [];
    tv.NodesAppearance.ExpandNodeIcon.LoadFromFile('uWebClientViewer.WebPanel3.tv.NodesAppearance.ExpandNodeIcon.svg');
    tv.NodesAppearance.CollapseNodeIcon.LoadFromFile('uWebClientViewer.WebPanel3.tv.NodesAppearance.CollapseNodeIcon.svg');
    tv.NodesAppearance.ExpandNodeIconLarge.LoadFromFile('uWebClientViewer.WebPanel3.tv.NodesAppearance.ExpandNodeIconLarge.svg');
    tv.NodesAppearance.CollapseNodeIconLarge.LoadFromFile('uWebClientViewer.WebPanel3.tv.NodesAppearance.CollapseNodeIconLarge.svg');
    tv.GlobalFont.Size := 12.000000000000000000;
    tv.GlobalFont.Name := 'Segoe UI';
    SetEvent(tv, Self, 'OnAfterSelectNode', 'tvAfterSelectNode');
    tv.DefaultViewJSONOptions.NameHTMLTemplate := '<#NAME>';
    tv.DefaultViewJSONOptions.ValueHTMLTemplate := '<#VALUE>';
    WebPanel4.SetParentComponent(WebPanel2);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 224;
    WebPanel4.Top := 0;
    WebPanel4.Width := 416;
    WebPanel4.Height := 448;
    WebPanel4.Margins.Left := 3;
    WebPanel4.Margins.Top := 3;
    WebPanel4.Margins.Right := 3;
    WebPanel4.Margins.Bottom := 3;
    WebPanel4.Align := alClient;
    WebPanel4.BorderStyle := bsNone;
    WebPanel4.ChildOrder := 1;
    pnlBot.SetParentComponent(WebPanel4);
    pnlBot.Name := 'pnlBot';
    pnlBot.Left := 0;
    pnlBot.Top := 388;
    pnlBot.Width := 416;
    pnlBot.Height := 60;
    pnlBot.Margins.Left := 3;
    pnlBot.Margins.Top := 3;
    pnlBot.Margins.Right := 3;
    pnlBot.Margins.Bottom := 3;
    pnlBot.Align := alBottom;
    pnlBot.ChildOrder := 1;
    ix.SetParentComponent(WebPanel4);
    ix.Name := 'ix';
    ix.Left := 0;
    ix.Top := 0;
    ix.Width := 416;
    ix.Height := 388;
    ix.Margins.Left := 3;
    ix.Margins.Top := 3;
    ix.Margins.Right := 3;
    ix.Margins.Bottom := 3;
    ix.Align := alClient;
    ix.BevelEdges := [];
    ix.BevelInner := bvNone;
    ix.BevelOuter := bvNone;
    ix.ParentDoubleBuffered := False;
    ix.DoubleBuffered := False;
    ix.TabOrder := 1;
    ix.Stroke.Kind := gskNone;
    ix.Stroke.Color := 11119017;
    ix.GroupsAppearance.TopSize := 100.000000000000000000;
    ix.GroupsAppearance.BottomSize := 100.000000000000000000;
    ix.GroupsAppearance.TopFill.Kind := gfkNone;
    ix.GroupsAppearance.TopFill.ColorTo := 16382457;
    ix.GroupsAppearance.BottomFill.Kind := gfkNone;
    ix.GroupsAppearance.BottomFill.ColorTo := 16382457;
    ix.GroupsAppearance.TopFont.Charset := DEFAULT_CHARSET;
    ix.GroupsAppearance.TopFont.Color := 4539717;
    ix.GroupsAppearance.TopFont.Height := -19;
    ix.GroupsAppearance.TopFont.Name := 'Segoe UI';
    ix.GroupsAppearance.TopFont.Style := [];
    ix.GroupsAppearance.BottomFont.Charset := DEFAULT_CHARSET;
    ix.GroupsAppearance.BottomFont.Color := 4539717;
    ix.GroupsAppearance.BottomFont.Height := -19;
    ix.GroupsAppearance.BottomFont.Name := 'Segoe UI';
    ix.GroupsAppearance.BottomFont.Style := [];
    ix.Columns.Clear;
    with ix.Columns.Add do
    begin
      Name := 'Column0';
      Text := 'Name';
      Width := 200.000000000000000000;
      UseDefaultAppearance := False;
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clBlack;
      Font.Height := -14;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      TopFont.Charset := DEFAULT_CHARSET;
      TopFont.Color := clWindowText;
      TopFont.Height := -22;
      TopFont.Name := 'Segoe UI';
      TopFont.Style := [];
      BottomFont.Charset := DEFAULT_CHARSET;
      BottomFont.Color := clWindowText;
      BottomFont.Height := -22;
      BottomFont.Name := 'Segoe UI';
      BottomFont.Style := [];
      Filtering.DropDownWidth := 200;
      Filtering.DropDownHeight := 240;
      Filtering.ButtonSize := 30.000000000000000000;
    end;
    with ix.Columns.Add do
    begin
      CustomEditor := True;
      Name := 'Column1';
      Text := 'Value';
      Width := 200.000000000000000000;
      UseDefaultAppearance := False;
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clTeal;
      Font.Height := -14;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      TopFont.Charset := DEFAULT_CHARSET;
      TopFont.Color := clWindowText;
      TopFont.Height := -22;
      TopFont.Name := 'Segoe UI';
      TopFont.Style := [];
      BottomFont.Charset := DEFAULT_CHARSET;
      BottomFont.Color := clWindowText;
      BottomFont.Height := -22;
      BottomFont.Name := 'Segoe UI';
      BottomFont.Style := [];
      Filtering.DropDownWidth := 200;
      Filtering.DropDownHeight := 240;
      Filtering.ButtonSize := 30.000000000000000000;
    end;
    ix.ColumnsAppearance.StretchColumn := 1;
    ix.ColumnsAppearance.StretchAll := False;
    ix.ColumnsAppearance.TopSize := 36.000000000000000000;
    ix.ColumnsAppearance.BottomSize := 50.000000000000000000;
    ix.ColumnsAppearance.TopFont.Charset := DEFAULT_CHARSET;
    ix.ColumnsAppearance.TopFont.Color := 4539717;
    ix.ColumnsAppearance.TopFont.Height := -19;
    ix.ColumnsAppearance.TopFont.Name := 'Segoe UI';
    ix.ColumnsAppearance.TopFont.Style := [fsBold];
    ix.ColumnsAppearance.BottomFont.Charset := DEFAULT_CHARSET;
    ix.ColumnsAppearance.BottomFont.Color := 4539717;
    ix.ColumnsAppearance.BottomFont.Height := -19;
    ix.ColumnsAppearance.BottomFont.Name := 'Segoe UI';
    ix.ColumnsAppearance.BottomFont.Style := [];
    ix.ColumnsAppearance.TopFill.Color := 16380654;
    ix.ColumnsAppearance.TopFill.ColorTo := 16382457;
    ix.ColumnsAppearance.BottomFill.Kind := gfkNone;
    ix.ColumnsAppearance.BottomFill.Color := 16380654;
    ix.ColumnsAppearance.BottomFill.ColorTo := 16382457;
    ix.ColumnsAppearance.TopStroke.Kind := gskNone;
    ix.NodesAppearance.ShowFocus := False;
    ix.NodesAppearance.ExpandWidth := 18.000000000000000000;
    ix.NodesAppearance.ExpandHeight := 18.000000000000000000;
    ix.NodesAppearance.LevelIndent := 2.000000000000000000;
    ix.NodesAppearance.FixedHeight := 25.000000000000000000;
    ix.NodesAppearance.VariableMinimumHeight := 10.000000000000000000;
    ix.NodesAppearance.ShowLines := False;
    ix.NodesAppearance.ColumnStroke.Color := clBlack;
    ix.NodesAppearance.Font.Charset := DEFAULT_CHARSET;
    ix.NodesAppearance.Font.Color := 8026746;
    ix.NodesAppearance.Font.Height := -19;
    ix.NodesAppearance.Font.Name := 'Segoe UI';
    ix.NodesAppearance.Font.Style := [];
    ix.NodesAppearance.TitleFont.Charset := DEFAULT_CHARSET;
    ix.NodesAppearance.TitleFont.Color := clBlack;
    ix.NodesAppearance.TitleFont.Height := -19;
    ix.NodesAppearance.TitleFont.Name := 'Segoe UI';
    ix.NodesAppearance.TitleFont.Style := [];
    ix.NodesAppearance.SelectedFontColor := 4539717;
    ix.NodesAppearance.SelectedTitleFontColor := clBlack;
    ix.NodesAppearance.ExtendedFontColor := 4539717;
    ix.NodesAppearance.SelectedFill.Color := 16578806;
    ix.NodesAppearance.SelectedStroke.Color := 15702829;
    ix.NodesAppearance.SelectedStroke.Width := 2.000000000000000000;
    ix.NodesAppearance.ExtendedStroke.Color := 15987699;
    ix.NodesAppearance.ExtendedFont.Charset := DEFAULT_CHARSET;
    ix.NodesAppearance.ExtendedFont.Color := clWindowText;
    ix.NodesAppearance.ExtendedFont.Height := -19;
    ix.NodesAppearance.ExtendedFont.Name := 'Segoe UI';
    ix.NodesAppearance.ExtendedFont.Style := [];
    ix.NodesAppearance.ExpandNodeIcon.LoadFromFile('uWebClientViewer.WebPanel4.ix.NodesAppearance.ExpandNodeIcon.svg');
    ix.NodesAppearance.CollapseNodeIcon.LoadFromFile('uWebClientViewer.WebPanel4.ix.NodesAppearance.CollapseNodeIcon.svg');
    ix.NodesAppearance.ExpandNodeIconLarge.LoadFromFile('uWebClientViewer.WebPanel4.ix.NodesAppearance.ExpandNodeIconLarge.svg');
    ix.NodesAppearance.CollapseNodeIconLarge.LoadFromFile('uWebClientViewer.WebPanel4.ix.NodesAppearance.CollapseNodeIconLarge.svg');
    ix.Interaction.MouseEditMode := tmemSingleClick;
    ix.Interaction.ColumnSizing := True;
    ix.Interaction.ColumnAutoSizeOnDblClick := True;
    ix.GlobalFont.Size := 7.000000000000000000;
    ix.GlobalFont.Name := 'Segoe UI';
    ix.DefaultViewJSONOptions.NameHTMLTemplate := '<#NAME>';
    ix.DefaultViewJSONOptions.ValueHTMLTemplate := '<#VALUE>';
    TMSFNCSplitter1.SetParentComponent(WebPanel2);
    TMSFNCSplitter1.Name := 'TMSFNCSplitter1';
    TMSFNCSplitter1.Left := 216;
    TMSFNCSplitter1.Top := 0;
    TMSFNCSplitter1.Width := 8;
    TMSFNCSplitter1.Height := 448;
    TMSFNCSplitter1.Cursor := crHSplit;
    TMSFNCSplitter1.Margins.Left := 3;
    TMSFNCSplitter1.Margins.Top := 3;
    TMSFNCSplitter1.Margins.Right := 3;
    TMSFNCSplitter1.Margins.Bottom := 3;
    TMSFNCSplitter1.Align := alLeft;
    TMSFNCSplitter1.BevelEdges := [];
    TMSFNCSplitter1.BevelInner := bvNone;
    TMSFNCSplitter1.BevelOuter := bvNone;
    TMSFNCSplitter1.ParentDoubleBuffered := False;
    TMSFNCSplitter1.DoubleBuffered := True;
    TMSFNCSplitter1.TabOrder := 2;
    TMSFNCSplitter1.Appearance.IndicatorFill.Color := clBlack;
    TMSFNCSplitter1.Appearance.IndicatorStroke.Color := clWhite;
    TMSFNCSplitter1.Appearance.SplitterDownStroke.Kind := gskNone;
    TMSFNCSplitter1.Appearance.SplitterHoverStroke.Kind := gskNone;
    TMSFNCSplitter1.Appearance.SplitterStroke.Color := 15329769;
    TMSFNCSplitter1.MinSize := 40.000000000000000000;
    TMSFNCSplitter1.SplitterIndicator := siSquares;
  finally
    pnlMain.AfterLoadDFMValues;
    pnlTop.AfterLoadDFMValues;
    lbc.AfterLoadDFMValues;
    lbt.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    tv.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    pnlBot.AfterLoadDFMValues;
    ix.AfterLoadDFMValues;
    TMSFNCSplitter1.AfterLoadDFMValues;
  end;
end;

end.